import React from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
}                                       from '@material-ui/core';

import { makeStyles, useTheme }         from '@material-ui/core/styles';

import { PieChart }                     from 'react-minimal-pie-chart';

import { 
  fmtDaysHrsMinFromSecs as fmtSecs,
  fmtPercent,
}                                       from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    padding: theme.spacing(1),
    paddingRight: theme.spacing(2),
    width: 'auto',
    minWidth: '170px',
    maxWidth: '250px',
  },
  table: {
  },
  cell: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '&:first-child': {
      paddingLeft: 0,
    },
    '&:last-child': {
      paddingRight: 0,
    },
  },
  graph: {
    minWidth: '75px',
    maxWidth: '75px',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

export default function ExecutionInputTimings(props) {
    
  const { value, variant } = props;
  
  const attempt=value;
  
  const classes = useStyles();
  const theme = useTheme();

  const transferColor = 'grey';
  const workloadColor = theme.palette.primary.main;
  const controllerColor = theme.palette.warning.main;

  const overallSecs = attempt.OverallSecs || 0;
  const downloadSecs = attempt.DownloadSecs || 0;
  const workloadSecs = attempt.WorkloadSecs || 0;
  const uploadSecs = attempt.UploadSecs || 0;
  const transferSecs = downloadSecs + uploadSecs;
  const controllerSecs = (overallSecs - transferSecs - workloadSecs) || 0;
  
  if(variant==='table') {
    return (
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} size="small">
          <TableBody>
            <TableRow>
              <TableCell className={classes.cell}><Typography variant='caption'><span style={{ backgroundColor: workloadColor}}>&nbsp;</span>&nbsp;Workload</Typography></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(workloadSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtPercent(workloadSecs,overallSecs)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><Typography variant='caption'><span style={{ backgroundColor: controllerColor}}>&nbsp;</span>&nbsp;Controller</Typography></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(controllerSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtPercent(controllerSecs,overallSecs)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.cell}><Typography variant='caption'><span style={{ backgroundColor: transferColor}}>&nbsp;</span>&nbsp;Transfer</Typography></TableCell>
              <TableCell className={classes.cell} align="right">{fmtSecs(transferSecs,'s')}</TableCell>
              <TableCell className={classes.cell} align="right">{fmtPercent(transferSecs,overallSecs)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  } else {
    return(
      <div className={classes.graph}>
        <PieChart style={{ height: '50px' }}
          animate
          //rounded
          //lineWidth={40}
          paddingAngle={5}
          lengthAngle={350}
          startAngle={275}
          //totalValue={5}
          // label={() => (overallSecs<240?"~":"")+Math.round(overallSecs/60)}
          // labelStyle={{
          //   fontSize: '20px',
          //   fontFamily: 'sans-serif',
          // }}
          // labelPosition={0}
          data={[
            { title: 'Download', value: downloadSecs, color: transferColor },
            { title: 'Workload', value: workloadSecs, color: workloadColor },
            { title: 'PostProcess', value: controllerSecs, color: controllerColor },
            { title: 'Upload', value: uploadSecs, color: transferColor },
          ].filter((item) => item.value>0)}
        />
        <Typography variant="caption">
          {(overallSecs<240?"~":"")+Math.round(overallSecs/60)} min
        </Typography>
      </div>
    );
  }
}

ExecutionInputTimings.propTypes = {
  value: PropTypes.object.isRequired,
  variant: PropTypes.string.isRequired,
};

ExecutionInputTimings.defaultProps = {
  variant: 'table',
};
